<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            @if (_context.mode !== FormMode.Creation) {
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Nom</mat-label>
                        <input matInput data-input-name type="text" formControlName="name" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Code facturation</mat-label>
                        <input matInput data-input-name type="text" formControlName="billingCode" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Date de création</mat-label>
                        <input matInput data-input-name type="text" formControlName="creationDate" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Date de dernière mise à jour</mat-label>
                        <input matInput data-input-name type="text" formControlName="updateDate" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
